import { render, staticRenderFns } from "./MidiaTextoVerticalView.vue?vue&type=template&id=21aa2a90&scoped=true"
import script from "./MidiaTextoVerticalView.vue?vue&type=script&lang=js"
export * from "./MidiaTextoVerticalView.vue?vue&type=script&lang=js"
import style0 from "./MidiaTextoVerticalView.vue?vue&type=style&index=0&id=21aa2a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa2a90",
  null
  
)

export default component.exports